import { useState, useEffect } from "react";
import { useModal } from "../../contexts/ModalContext";

const GuestMenu = () => {
  const { openModal } = useModal();
  const [showLogin, setShowLogin] = useState(true);
  const [showSignUp, setShowSignUp] = useState(true);

  useEffect(() => {
    if (window.location.pathname?.includes("/login")) setShowLogin(false);
    if (window.location.pathname?.includes("/register")) setShowSignUp(false);
  }, []);

  return (
    <>
      {
        showLogin &&
        <button id="login-btn"
          onClick={() => openModal("login")}
        >
          Log In
        </button>
      }

      {showSignUp &&
        <button
          onClick={() => openModal("register")}
          className="rounded-btn"
        >
          Sign Up
        </button>
      }
    </>
  );
}
export default GuestMenu;